import * as React from 'react';

import { Dialog, Typography2 } from '@coursera/cds-core';

import { useEnterpriseAdminPermissions } from 'bundles/enterprise-admin-roles/components/EnterprisePermissionsProvider';
import { Button } from 'bundles/enterprise-ui';

import _t from 'i18n!nls/admin-dashboard';

export const ProgramAdministratorPrivilegesConfirmation: React.VFC<{ onConfirm: () => void }> = ({ onConfirm }) => {
  const { getIsOrganizationDomainAdmin } = useEnterpriseAdminPermissions();
  const isOrgLevel = getIsOrganizationDomainAdmin();
  return (
    <Dialog open data-e2e="program-administrator-privileges-confirmation" variant="transactional" color="darkBlue">
      <Dialog.HeadingGroup>
        {isOrgLevel
          ? _t('You have been granted administrator privileges')
          : _t('You have been granted program administrator privileges')}
      </Dialog.HeadingGroup>
      <Dialog.Content>
        <Typography2 component="p">
          {isOrgLevel
            ? _t(
                'As an organization administrator you can manage learners and administrators across your entire organization.'
              )
            : _t('As a program administrator you can manage learners within your designated learning programs.')}
        </Typography2>
      </Dialog.Content>
      <Dialog.Actions>
        <Button variant="primary" onClick={onConfirm} data-e2e="ok">
          {_t('OK')}
        </Button>
      </Dialog.Actions>
    </Dialog>
  );
};
